import React from "react";

import { Size } from "src/theme";

import Shimmer from "./Shimmer";

export const SubheadingShimmer = () => (
  <Shimmer width="18rem" textSize={Size.LARGE} />
);
